export const DepartGroups = {
  REEFERS: 1,
  VAN_CONT_OTOP_CURT_LIVE_TANK_HOP: 2,
  SIDE_FLAT: 3,
};

export type DepartGroups = (typeof DepartGroups)[keyof typeof DepartGroups];
